import { render } from "./gamesReport.vue?vue&type=template&id=6220bfdc&scoped=true"
import script from "./gamesReport.vue?vue&type=script&lang=js"
export * from "./gamesReport.vue?vue&type=script&lang=js"

import "./gamesReport.vue?vue&type=style&index=0&id=6220bfdc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6220bfdc"]])

export default __exports__